var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"svg-stroke","fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeLinecap":"square","strokeWidth":"2","transform":"translate(1 1)"},React.createElement("path",{"d":"M5 .327183315L5 9.48831613M10.1611328 5L.161132812 5"})));
}

Plus.defaultProps = {"width":"13","height":"12","viewBox":"0 1 13 12"};

module.exports = Plus;

Plus.default = Plus;
